export const maskEINLast4 = (ein?: string | number | null): string => {
  if (ein === null || ein === undefined) return "-";

  const raw = String(ein).replace(/\D/g, "");
  if (!raw) return "-";

  if (raw.length <= 4) return raw;

  return `***-**-${raw.slice(-4)}`;
};

